import sanitizeInput from "./senetizeInput";

const { Form } = require("react-bootstrap")

const TextAreaField = ({
    rows,
    name,
    value,
    handleChange,
    isInvalid,
    customClass,
    placeholder,
    onFocus
})=>{
  const handleInputChange = (e) => {
    const sanitizedValue = sanitizeInput(e.target.value);
    const sanitizedEvent = {
      ...e,
      target: {
        name:e.target.name,
        value: sanitizedValue,
      },
    };
    handleChange(sanitizedEvent);
  };
  return (
    <Form.Control
      className={`item-add-textarea ${customClass}`}
      as="textarea"
      rows={rows || 2}
      name={name}
      placeholder={placeholder || "Type Here..."}
      value={value}
      onChange={handleInputChange}
      isInvalid={isInvalid}
      onFocus={onFocus}
    />
  );
}

export default TextAreaField;